import React, { useState } from "react";
import WhatsAppButton from "./buttons/WhatsAppButton";
import EmailButton from "./buttons/EmailButton";
import WebsiteButton from "./buttons/WebsiteButton";
import MapsButton from "./buttons/MapsButton";
import SocialMediaButton from "./buttons/SocialMediaButton";
import VcfButton from "./buttons/VcfButton";
import ShareButton from "./buttons/ShareButton";
import ShareModal from "./modal/ShareModal";
import "./contactInfo.css";

const ContactInfo = ({ buttons, slogan, slug }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { website, location, phone, email, social, vcfFile, qrCode } = buttons;
  const { facebook, instagram, twitter, tiktok, linkedin } = social;
  const profileLink = `https://mitedi.com/${slug}`;
  const vcfFileName = `${slug}.vcf`;

  const facebookButton = facebook ? (
    <SocialMediaButton platform="Facebook" link={facebook} />
  ) : null;
  const instagramButton = instagram ? (
    <SocialMediaButton platform="Instagram" link={instagram} />
  ) : null;
  const linkedinButton = linkedin ? (
    <SocialMediaButton platform="LinkedIn" link={linkedin} />
  ) : null;
  const twitterButton = twitter ? (
    <SocialMediaButton platform="Twitter" link={twitter} />
  ) : null;
  const tiktokButton = tiktok ? (
    <SocialMediaButton platform="TikTok" link={tiktok} />
  ) : null;

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="contact-info">
      <div className="icon-row first-row">
        <WebsiteButton website={website} />
        <MapsButton location={location} />
        {facebookButton}
        {instagramButton}
        {linkedinButton}
      </div>
      <div className="icon-row second-row">
        <WhatsAppButton number={phone} />
        <EmailButton email={email} />
        {twitterButton}
        {tiktokButton}
        <VcfButton file={vcfFile} fileName={vcfFileName} />
        <ShareButton onClick={toggleModal} />
        <ShareModal
          image={qrCode}
          toggleModal={toggleModal}
          isOpen={isOpen}
          link={profileLink}
        />
      </div>
      <div className="description">
        <p>{slogan}</p>
      </div>
    </div>
  );
};

export default ContactInfo;
